import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { LocalizationService } from '@app/core';
import { maxImageSize } from '@app/shared/common/constants';
import { SpinnerHandlerService } from '@app/shared/components/loader/spinner-handler.service';
import { UploadFileService } from '@app/vinter/services/upload-file.service';
import { VgApiService } from '@videogular/ngx-videogular/core';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-audio-uploader-simple',
  templateUrl: './audio-uploader-simple.component.html',
  styleUrls: ['./audio-uploader-simple.component.scss']
})
export class AudioUploaderSimpleComponent implements OnInit {

  @Output() onFileSelect: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onAudioConfirm: EventEmitter<any> = new EventEmitter<any>();
  isSelected: boolean = false;
  uploadedFiles: any[] = [];
  visible: boolean = true;
  fileName: string;
  audioUrl: string;
  media: any;
  maxSizeImage: number = maxImageSize;

  @Output() closeDialog: EventEmitter<any> = new EventEmitter<any>();
  @Output() uploadAudioUrl: EventEmitter<any[]> = new EventEmitter<any[]>();
  @ViewChild(FileUpload, { static: false }) fileUpload: FileUpload;
  @ViewChild('fileInput') fileInput: FileUpload;

    constructor(private api: VgApiService,
      public service: UploadFileService,
      private spinner: SpinnerHandlerService,
      private messageService: MessageService,
      private localizationService: LocalizationService) { this.api = api; }


  ngOnInit() {
  }

  onFileSelected(event: any): void {
    if (event.files[0].type != "audio/mp3" && event.files[0].type != "audio/mpeg"){
        return;
    }
    if(event.files[0].size > this.maxSizeImage){
        this.messageService.add({
            severity: 'error',
            summary: this.localizationService.translatedTextList.Error,
            detail: this.localizationService.translatedTextList.InvalidImageSize,
            life: 3000
        });
        return;
    }
    this.fileName = event.files[0].name;
    this.onFileSelect.emit(true);
    this.audioUrl = URL.createObjectURL(event.files[0]);
    this.isSelected = true; 
}

selectFile(){
    this.fileInput.choose();
  }


onConfirm(): Promise<any> {
    return new Promise<any>(async(resolve, reject) => {
        let blob = await fetch(this.audioUrl).then((r) => r.blob());
        var file = new File([blob], "audio1.mp3");
        let formData = new FormData();
        formData.append("audio", file);
        this.service.uploadAudioToS3(formData).subscribe(response => {
            this.onAudioConfirm.emit({ link: response, id: null });
            this.uploadAudioUrl.emit(response);
            this.closeDialog.emit(null);
            resolve(response);
        },
        err => {
            reject(err);
        });
        this.onClear();
    });
  }


onClear(){
    this.isSelected = false;
    this.audioUrl = null;
    this.uploadedFiles = [];
    this.fileUpload.clear();
}
}
